
/*HOMEPAGE WALKING DOG ANIMATION*/

const dog = document.querySelector('.walking-dog');
if (dog) {
  const section = document.querySelector('.walking-dog').closest('section');

  function handleScroll() {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    const scrollY = window.scrollY + window.innerHeight;
    const extendedScroll = sectionHeight * 3; // or 1.5, 2.5, etc.
const scrollPercent = Math.min(Math.max((scrollY - sectionTop) / extendedScroll, 0), 1);


    const screenWidth = window.innerWidth;
    const dogWidth = dog.offsetWidth;

    const startX = 48; // aligned right
    const endX = screenWidth - dogWidth - 48; // 3rem from left

    const currentX = startX + scrollPercent * (endX - startX);

    const step = Math.sin(scrollPercent * Math.PI * 6);
    const bounce = step * 8;
    const rotate = step * 4;

dog.style.transform = `translateX(-${currentX}px) translateY(calc(-5vw + ${bounce}px)) rotate(${rotate}deg)`;
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  handleScroll(); // call once on load
}






if (window.matchMedia('(max-width: 749px)').matches) {
  const dog = document.querySelector('.walking-dog-mobile');
  if (dog) {
    const section = dog.closest('section');

    function handleScrollMobile() {
      const sectionTop = section.offsetTop + 200; // delays start by 100px
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY + window.innerHeight;

      // Shorter scroll range for faster movement
      const extendedScroll = sectionHeight * 1.2;
      const scrollPercent = Math.min(Math.max((scrollY - sectionTop) / extendedScroll, 0), 1);

      const screenWidth = window.innerWidth;
      const dogWidth = dog.offsetWidth;

      // Start fully off the right edge
    const startX = 0; // aligned right
    const endX = screenWidth - dogWidth - 24; // 3rem from left

      const currentX = startX - scrollPercent * (startX - endX);

      const step = Math.sin(scrollPercent * Math.PI * 5);
      const bounce = step * 10;
      const rotate = step * 5;

dog.style.transform = `translateX(-${currentX}px) translateY(calc(-5vw + ${bounce}px)) rotate(${rotate}deg)`;
    }

    window.addEventListener('scroll', handleScrollMobile);
    window.addEventListener('resize', handleScrollMobile);
    handleScrollMobile();
  }
}








/* FOOTER DOG PLAYING WITH BEACHBALL - PAGE-SPECIFIC */



if (window.matchMedia('(min-width: 750px)').matches) {
document.addEventListener('DOMContentLoaded', () => {
  const isDadPage = document.body.classList.contains('template-name--about-dad-mode');

  // Use the correct elements depending on page
  const section = document.querySelector(isDadPage ? '.footer-grass.blue-grass' : '.footer-grass:not(.blue-grass)');
  const dog = section?.querySelector('.footer-dog');
  const ball = section?.querySelector('.footer-beachball');

  if (section && dog && ball) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          startAnimation();
          observer.disconnect();
        }
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  }

  function startAnimation() {
    const walkDuration = 5000;
    const jumpDuration = 3000;
    const totalDuration = walkDuration + jumpDuration;
    const startTime = performance.now();

    const screenWidth = window.innerWidth;
    const dogStartX = 0;
    const dogEndX = screenWidth * 0.45;

    const ballStartX = screenWidth * 0.05;
    const ballEndX = screenWidth * 0.45;

    let finalDogY = 0;
    let finalBallY = 0;

    function easeOutQuad(t) {
      return t * (2 - t);
    }

    function animate(time) {
      const elapsed = time - startTime;

      if (elapsed < walkDuration) {
        const progress = elapsed / walkDuration;
        const easedProgress = easeOutQuad(progress);

        const step = Math.sin(progress * Math.PI * 7);
        const bounce = step * 8;
        const rotate = step * 4;

        const dogX = dogStartX + easedProgress * (dogEndX - dogStartX);
        const ballX = ballStartX + easedProgress * (ballEndX - ballStartX);

        finalDogY = -5 * window.innerHeight / 100 + bounce;
        finalBallY = -10 * window.innerHeight / 100 + bounce * 1.5;

        dog.style.zIndex = 2;
        ball.style.zIndex = 3;

        dog.style.transform = `translateX(${dogX}px) translateY(${finalDogY}px) rotate(${rotate}deg)`;
        ball.style.transform = `translateX(${ballX}px) translateY(${finalBallY}px) rotate(${progress * 720}deg)`;

        requestAnimationFrame(animate);
      } else if (elapsed < totalDuration) {
        const jumpProgress = (elapsed - walkDuration) / jumpDuration;

        const jumpOffsetDogY = -20 * Math.sin(jumpProgress * Math.PI);
        const dogRotate = -10 * Math.sin(jumpProgress * Math.PI);
        const flipped = jumpProgress > 0.8;

        dog.style.transform = `translateX(${dogEndX}px) translateY(${finalDogY + jumpOffsetDogY}px) rotate(${dogRotate}deg)${flipped ? ' scaleX(-1)' : ''}`;

        const arcBackX = -450 * jumpProgress;
        const arcUpY = -300 * Math.sin(jumpProgress * Math.PI);

        ball.style.zIndex = 2;
        ball.style.transform = `translateX(${ballEndX + arcBackX}px) translateY(${finalBallY + arcUpY}px) rotate(${1080 + jumpProgress * 360}deg)`;

        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }
});
}




if (window.matchMedia('(max-width: 749px)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    const isDadPage = document.body.classList.contains('template-name--about-dad-mode');
    const section = document.querySelector(isDadPage ? '.footer-grass.blue-grass' : '.footer-grass:not(.blue-grass)');
    const dog = section?.querySelector('.footer-dog');
    const ball = section?.querySelector('.footer-beachball');

    if (section && dog && ball) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startMobileAnimation();
            observer.disconnect();
          }
        });
      }, { threshold: 0.2 });

      observer.observe(section);
    }

    function startMobileAnimation() {
      const walkDuration = 4000;
      const jumpDuration = 2500;
      const totalDuration = walkDuration + jumpDuration;
      const startTime = performance.now();

      const screenWidth = window.innerWidth;
      const dogStartX = 0;
      const dogEndX = screenWidth * 0.45; // shorter distance

      const ballStartX = screenWidth * 0.05;
      const ballEndX = screenWidth * 0.4;

      let finalDogY = 0;
      let finalBallY = 0;

      function easeOutQuad(t) {
        return t * (2 - t);
      }

      function animate(time) {
        const elapsed = time - startTime;

        if (elapsed < walkDuration) {
          const progress = elapsed / walkDuration;
          const easedProgress = easeOutQuad(progress);

          const step = Math.sin(progress * Math.PI * 6);
          const bounce = step * 6;
          const rotate = step * 3;

          const dogX = dogStartX + easedProgress * (dogEndX - dogStartX);
          const ballX = ballStartX + easedProgress * (ballEndX - ballStartX);

          finalDogY = -3 * window.innerHeight / 100 + bounce;
          finalBallY = -6 * window.innerHeight / 100 + bounce * 1.3;

          dog.style.zIndex = 2;
          ball.style.zIndex = 3;

          dog.style.transform = `translateX(${dogX}px) translateY(${finalDogY}px) rotate(${rotate}deg)`;
          ball.style.transform = `translateX(${ballX}px) translateY(${finalBallY}px) rotate(${progress * 720}deg)`;

          requestAnimationFrame(animate);
        } else if (elapsed < totalDuration) {
          const jumpProgress = (elapsed - walkDuration) / jumpDuration;

          const jumpOffsetDogY = -15 * Math.sin(jumpProgress * Math.PI);
          const dogRotate = -8 * Math.sin(jumpProgress * Math.PI);
          const flipped = jumpProgress > 0.8;

          dog.style.transform = `translateX(${dogEndX}px) translateY(${finalDogY + jumpOffsetDogY}px) rotate(${dogRotate}deg)${flipped ? ' scaleX(-1)' : ''}`;

          const arcBackX = -225 * jumpProgress; // shorter arc
          const arcUpY = -200 * Math.sin(jumpProgress * Math.PI); // smaller jump

          ball.style.zIndex = 2;
          ball.style.transform = `translateX(${ballEndX + arcBackX}px) translateY(${finalBallY + arcUpY}px) rotate(${1080 + jumpProgress * 360}deg)`;

          requestAnimationFrame(animate);
        }
      }

      requestAnimationFrame(animate);
    }
  });
}


















/*PAW PRINT ANIMATION

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.hero .button');
  const pawImage = 'https://cdn.shopify.com/s/files/1/0937/2532/7662/files/orange_paw_print_logo.png?v=1748103105';

  const pawPositions = [
    { left: window.innerWidth - 200, bottom: 250 },
    { left: window.innerWidth - 350, bottom: 150 },
    { left: window.innerWidth - 250, bottom: 0 },
    { left: window.innerWidth - 100, bottom: -50 }
  ];

  let pawPrints = [];

  button.addEventListener('mouseenter', () => {
    // Clear any existing paw prints
    pawPrints.forEach(p => p.remove());
    pawPrints = [];

    pawPositions.forEach((pos, i) => {
      setTimeout(() => {
        const img = document.createElement('img');
        img.src = pawImage;
        img.className = 'paw-print';
        img.style.position = 'fixed';
        img.style.left = `${pos.left}px`;
        img.style.bottom = `${pos.bottom}px`;
        img.style.width = '200px';
        img.style.opacity = '0';
        img.style.transition = 'opacity 0s ease, transform 0s ease';
        img.style.zIndex = '10';
        img.style.pointerEvents = 'none';
        img.style.transform = 'translateY(20px)';

        document.body.appendChild(img);
        pawPrints.push(img);

        requestAnimationFrame(() => {
          img.style.opacity = '1';
          img.style.transform = 'translateY(0)';
        });
      }, i * 200); // staggered appearance
    });
  });

  button.addEventListener('mouseleave', () => {
    pawPrints.forEach(p => p.remove());
    pawPrints = [];
  });
});

*/


/*BACKGROUND COLOR ON PRODUCT GRID*/

document.addEventListener('DOMContentLoaded', () => {
  // Only run this on collection pages
  if (!document.body.classList.contains('template-collection')) return;

  document.querySelectorAll('.template-collection .card-wrapper').forEach(card => {
    const bg = card.style.backgroundColor;

    if (bg) {
      // Find the image wrapper and apply the background
      const mediaWrapper = card.querySelector('.card__media');
      if (mediaWrapper) {
        mediaWrapper.style.backgroundColor = bg;
      }

      // Clear background from the full card
      card.style.backgroundColor = 'transparent';
    }
  });
});





/*PRODUCT LIST PSEUDO VARIANT BACKGROUND COLOR*/


document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector(".productlist-grid[data-current-bg-color]");
  if (!grid) return;

  const currentBgColor = grid.dataset.currentBgColor;
  const swatchItems = grid.querySelectorAll(".swatch-product-wrapper");

  // Add inline style for hover and active states
  if (currentBgColor) {
    const style = document.createElement("style");
    style.innerHTML = `
      .productlist-grid .swatch-product-wrapper:hover,
      .productlist-grid .swatch-product-wrapper.active-product {
        background-color: ${currentBgColor} !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Mark the matching swatch as active
  const currentPath = window.location.pathname.replace(/^\/+|\/+$/g, ''); // remove slashes
  swatchItems.forEach((item) => {
    const link = item.closest("a");
    if (!link) return;

    const hrefPath = link.getAttribute("href").replace(/^\/+|\/+$/g, ''); // remove slashes
    if (hrefPath === currentPath) {
      item.classList.add("active-product");
    }
  });
});







document.addEventListener("DOMContentLoaded", function () {
  const bgColorEl = document.getElementById("product-bg-color");
  if (!bgColorEl) return;

  const backgroundColor = bgColorEl.dataset.bg;
  if (!backgroundColor) return;

  // Create and inject hover styles
  const styleTag = document.createElement("style");
  styleTag.innerHTML = `
    #appstle_subscription_widget0 .appstle_subscription_wrapper_option:hover {
      background-color: ${backgroundColor} !important;
    }
  `;
  document.head.appendChild(styleTag);

  function updateAppstleBackgrounds() {
    const options = document.querySelectorAll("#appstle_subscription_widget0 .appstle_subscription_wrapper_option");
    options.forEach(option => {
      if (option.classList.contains("appstle-active-option")) {
        option.style.backgroundColor = backgroundColor;
      } else {
        option.style.backgroundColor = ""; // Reset non-active
      }
    });
  }

  function observeAppstleChanges() {
    const container = document.querySelector("#appstle_subscription_widget0");
    if (!container) {
      setTimeout(observeAppstleChanges, 200);
      return;
    }

    updateAppstleBackgrounds();

    const observer = new MutationObserver(updateAppstleBackgrounds);
    observer.observe(container, {
      attributes: true,
      subtree: true,
      attributeFilter: ["class"]
    });
  }

  observeAppstleChanges();
});




















/*PRODUCT PAGE TABS*/



document.addEventListener("DOMContentLoaded", () => {
  const accordionBlocks = document.querySelectorAll(".product__accordion");

  if (!accordionBlocks.length) return;

  const tabWrapper = document.createElement("div");
  tabWrapper.className = "product-tabs";

  const tabNav = document.createElement("ul");
  tabNav.className = "product-tabs__nav";

  const tabPanels = document.createElement("div");
  tabPanels.className = "product-tabs__panels";

  accordionBlocks.forEach((block, index) => {
    const summary = block.querySelector("summary");
    const title = summary?.querySelector("h2")?.innerText?.trim() || `Tab ${index + 1}`;
    const content = block.querySelector(".accordion__content");

    if (!title || !content) return;

    const tabId = `product-tab-${index}`;

    // Create tab button
    const tabButton = document.createElement("li");
    tabButton.innerHTML = `<button class="product-tabs__nav-button" data-tab="${tabId}">${title}</button>`;
    if (index === 0) tabButton.querySelector("button").classList.add("active");
    tabNav.appendChild(tabButton);

    // Create content panel
    const panel = document.createElement("div");
    panel.className = "product-tabs__panel";
    panel.id = tabId;
    panel.innerHTML = content.innerHTML;
    if (index === 0) panel.classList.add("active");
    tabPanels.appendChild(panel);
  });

  tabNav.addEventListener("click", (e) => {
    const button = e.target.closest(".product-tabs__nav-button");
    if (!button) return;

    const targetId = button.dataset.tab;

    document.querySelectorAll(".product-tabs__nav-button").forEach(btn => btn.classList.remove("active"));
    document.querySelectorAll(".product-tabs__panel").forEach(panel => panel.classList.remove("active"));

    button.classList.add("active");
    document.getElementById(targetId)?.classList.add("active");
  });

  tabWrapper.appendChild(tabNav);
  tabWrapper.appendChild(tabPanels);

  // Insert before the first accordion
  accordionBlocks[0].parentNode.insertBefore(tabWrapper, accordionBlocks[0]);

  // Remove all accordion markup
  accordionBlocks.forEach(block => block.remove());
});



/* WALKING SQUIRREL */

document.addEventListener('DOMContentLoaded', function () {
  const squirrel = document.querySelector('.walking-squirrel');
  if (!squirrel) return;

  const section = squirrel.closest('section');
  if (!section) return;

  let ticking = false;

  function handleScroll() {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    const scrollTop = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;
    const scrollY = scrollTop + windowHeight;
    const extendedScroll = sectionHeight * 3;

    const delayStart = 0.4;
    let rawScrollPercent = (scrollY - sectionTop) / extendedScroll;
    let scrollPercent = Math.min(Math.max((rawScrollPercent - delayStart) / (1 - delayStart), 0), 1);

    const screenWidth = window.innerWidth;
    const squirrelWidth = squirrel.offsetWidth;

    const startX = 24;
    const endX = screenWidth - squirrelWidth + 120;
    const currentX = startX + scrollPercent * (endX - startX);

    const step = Math.sin(scrollPercent * Math.PI * 6);
    const bounce = step * 8;
    const rotate = step * 4;

    const arcHeight = 50;
    const arc = -Math.sin(scrollPercent * Math.PI) * arcHeight;

    squirrel.style.transform = `translate3d(-${currentX}px, ${arc + bounce}px, 0) rotate(${rotate}deg)`;

    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    },
    { passive: true }
  );

  window.addEventListener('resize', handleScroll);

  handleScroll();
});



/*MAGGIE'S TREATS*/


document.addEventListener("DOMContentLoaded", function () {
  const pawSection = document.querySelector('#section-template--24555440144686__power_section_kFitrW');
  const paws = [
    document.querySelector('.green-paw-one'),
    document.querySelector('.green-paw-two'),
    document.querySelector('.green-paw-three'),
    document.querySelector('.green-paw-four')
  ];

  let hasAnimated = false;

  function animatePaws() {
    paws.forEach((paw, index) => {
      paw.style.opacity = '0';
      paw.style.transition = 'transform 0.6s ease, opacity 0.6s ease';
      paw.style.transform = 'translateY(20px)';
    });

    setTimeout(() => {
      paws.forEach((paw, index) => {
        setTimeout(() => {
          paw.style.opacity = '1';
          paw.style.transform = 'translateY(0)';
        }, index * 200); // delay between each paw
      });
    }, 300); // start delay
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animatePaws();
        } else {
          // Reset for repeat animation
          paws.forEach(paw => {
            paw.style.opacity = '0';
            paw.style.transform = 'translateY(20px)';
          });
        }
      });
    },
    { threshold: 0.4 }
  );

  if (pawSection) {
    observer.observe(pawSection);
  }
});





document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-plus-button').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.stopPropagation(); // prevent card link from capturing
    });
  });
});




/* PARALLAX EFFECT ON DADS MODE */

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('section:has(.dad-mode)');
  if (!section) return;

  const images = section.querySelectorAll('.dad-mode .ss-inline-img');
  if (!images.length) return;

  let ticking = false;

  function updateParallax() {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    const scrollTop = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;

    if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
      let scrollProgress = (scrollTop + windowHeight - sectionTop) / (sectionHeight + windowHeight);

      const delayThreshold = 0.45;

      if (scrollProgress < delayThreshold) {
        scrollProgress = 0;
      } else {
        scrollProgress = (scrollProgress - delayThreshold) / (1 - delayThreshold);
      }

      images.forEach((img, index) => {
        const speed = (index + 1) * 150;
        const translateY = scrollProgress * speed;

        img.style.transform = `translate3d(0, -${translateY}px, 0)`;
      });
    }

    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    },
    { passive: true }
  );

  updateParallax();
});








/*MAGGIE AND HER DADS ANIMATION*/

document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.and-her-dads .ss-image-wrapper');

  if (target) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          target.classList.add('fade-in-overlay');
        }
      });
    }, { threshold: 0.8 }); // Trigger when 20% is visible

    observer.observe(target);
  }
});







